import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot", { email });
      setSent(true);
    } catch (err) {
      toast.error("Something went wrong. Try again.");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center px-4 bg-slate-50">
      <Card className="w-full max-w-md p-8 rounded-2xl">
        <Link to="/" className="inline-block mb-6"><div className="font-display font-bold text-primary text-xl">Job Done Reviews</div></Link>
        <h1 className="font-display text-2xl font-bold mb-1">Reset your password</h1>
        <p className="text-slate-500 mb-6 text-sm">We'll email you a link to reset it.</p>
        {sent ? (
          <div className="rounded-xl bg-blue-50 border border-blue-100 p-4 text-blue-900 text-sm" data-testid="forgot-sent">
            If an account exists for that email, we've sent a reset link. Check your inbox.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-lg" placeholder="you@business.com" />
            <Button data-testid="forgot-submit" disabled={busy} type="submit" className="w-full h-12 rounded-full bg-primary hover:bg-primary/90">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="text-center text-sm text-slate-500 mt-6"><Link to="/login" className="text-primary hover:underline" data-testid="forgot-back">Back to log in</Link></p>
      </Card>
    </div>
  );
}
